export function formatUserFacingNumber(numberToFormat: number): string {
  const language = window.navigator.language;

  return numberToFormat.toLocaleString([language, "en-US"], {
    maximumFractionDigits: 0,
  });
}
